import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-declaration-modal',
  templateUrl: './declaration-modal.component.html',
  styleUrls: ['./declaration-modal.component.css'],
})
export class DeclarationModalComponent implements OnInit {
  private submitApi = environment.url + 'preincubation/submit';
  /**
   * Constructs a new DeclarationModalComponent.
   * @param makeapi The api service, which is used to make the api call to submit the pre-incubation form.
   * @param dialog The dialog service, which is used to close the dialog.
   * @param dialogRef The dialog reference, which is used to close the dialog.
   */
  constructor(
    private makeapi: ApiService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<DeclarationModalComponent>
  ) {}

  ngOnInit(): void {}
  /**
   * Closes the dialog without performing any additional actions.
   * This is typically called when the user cancels the registration process.
   */
  cancelReg() {
    // Close the dialog reference
    this.dialogRef.close();
  }
  /**
   * This function sends a POST request to the submit API endpoint
   * to submit the pre-incubation form.
   */
  submiteApi() {
    // Create an empty object to send as the request body
    let getform = {};

    // Call the API method to send the request
    this.makeapi.method(this.submitApi, getform, 'post').subscribe((data) => {
      // If the response status is 'Success', close the dialog
      if (data.responseStatus == 'Success') {
        this.cancelReg();
      }
    });
  }
}
